import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import { API_BASE_URL } from "@/config";
import { validateToken } from "@/utils/auth";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";

export default {
  name: "TrustSearchVerification",
  mixins: [MAIN_CONTROLLER, PREPOPULATE_INPUT],
  components: {
    BreadCrumb,
    ClientLogo,
  },

  data() {
    return {
      trust_name: "",
      trust_results: null,
      trust_details: null,
      selected_trust_id: null,
      loading: false,
      error: "",
      auto_submitted: false,
      new_trust: {
        trust_name: "",
        file_number: "",
        masters_office: "",
      },
      masters_offices: [
        "Pretoria Masters Office",
        "Cape Town Masters Office",
        "Durban Masters Office",
        "Johannesburg Masters Office",
        "Bloemfontein Masters Office",
        "Port Elizabeth Masters Office",
        "Kimberley Masters Office",
        "Pietermaritzburg Masters Office",
        "Thohoyandou Masters Office",
        "Mmabatho Masters Office",
        "Nelspruit Masters Office",
        "Grahamstown Masters Office",
        "Mthatha Masters Office"
      ],
    };
  },

  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
    should_auto_submit() {
      return this.trust_name && !this.auto_submitted;
    },
  },

  methods: {
    get_trust_information() {
      const TOKEN = localStorage.getItem("token");
      const GET_TRUST_INFO_API = `${API_BASE_URL}/verify_api/compliance_verification/get_trust_information/${this.workflow_id}/`;

      this.loading = true;
      this.error = "";

      $.ajax({
        url: GET_TRUST_INFO_API,
        method: "GET",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        success: (response) => {
          this.loading = false;

          if (
            response.status === "success" &&
            response.data &&
            response.data.length > 0
          ) {
            // Show trust details directly if found
            this.trust_results = response.data;
          } else {
            // No data → allow manual search
            this.trust_results = null;
          }
        },
        error: () => {
          this.loading = false;
          this.trust_results = null;
        },
      });
    },

    submit_trust_search() {
      this.auto_submitted = false;

      if (!this.trust_name.trim()) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Trust name cannot be empty!",
          timer: 3000,
          showConfirmButton: false,
        });
        return false;
      }

      this.trust_search();
    },

    trust_search() {
      const TOKEN = localStorage.getItem("token");
      const TRUST_SEARCH_API = `${API_BASE_URL}/verify_api/compliance_verification/trust_search/`;

      this.auto_submitted = true;
      this.loading = true;
      this.error = "";

      const DATA = {
        trust_name: this.trust_name,
        workflow_id: this.workflow_id,
        on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
      };

      Swal.fire({
        title: "Searching Trusts",
        text: "Please wait while we search for trust information...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      $.ajax({
        url: TRUST_SEARCH_API,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(DATA),
        success: (response) => {
          Swal.close();
          this.loading = false;

          if (response.status === "success" && response.result) {
            this.trust_results = response.result;
          } else {
            this.trust_results = [];
            Swal.fire({
              icon: "info",
              title: "No Results",
              text: "No trusts found matching your search criteria.",
              timer: 3000,
              showConfirmButton: false,
            });
          }
        },
        error: (error) => {
          this.loading = false;
          this.auto_submitted = false;
          Swal.close();

          let error_message = "Something went wrong!";
          if (error.responseJSON && error.responseJSON.message) {
            error_message = error.responseJSON.message;
          }

          Swal.fire({
            icon: "error",
            title: "Search Error",
            text: error_message,
            timer: 3000,
            showConfirmButton: false,
          });
        },
      });
    },

    select_trust(trust_id) {
      this.save_trust_selection(trust_id, true);
    },

    save_trust_selection(trust_id, selected) {
      const TOKEN = localStorage.getItem("token");
      const SAVE_TRUST_API = `${API_BASE_URL}/verify_api/compliance_verification/trust_data_fetch/`;

      this.loading = true;
      this.error = "";

      const DATA = {
        trust_id: trust_id,
        workflow_id: this.workflow_id,
        selected: selected,
        on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
      };

      $.ajax({
        url: SAVE_TRUST_API,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(DATA),
        beforeSend: () => {
          Swal.fire({
            text: "Saving trust information...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
        },
        success: () => {
          Swal.close();
          this.completeService();
        },
        error: (error) => {
          this.loading = false;
          Swal.close();
          let error_message =
            "Could not save trust information! Please try again later.";

          if (error.responseJSON && error.responseJSON.message) {
            error_message = error.responseJSON.message;
          }

          Swal.fire({
            icon: "error",
            title: "Error",
            text: error_message,
            timer: 3000,
            showConfirmButton: false,
          });
        },
      });
    },
  },

  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    this.get_trust_information();
  },
};
